/* eslint-disable default-case */
import React from 'react'
import connect from "react-redux/es/connect/connect"
import { withStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import Grid from '@material-ui/core/Grid'
import OverridableAttendanceTypesDialog from "apps/admin/components/OverridableAttendanceTypesDialog";
import Tooltip from '@material-ui/core/Tooltip';
import InfoIcon from '@material-ui/icons/Info';

import {
  findOneBy,
} from '@relativity/js-util'

import {
  bellRulesEditDone,
  bellRulesEditUpdateProperty,
  bellRulesEditSave,
  overridableAtTypesEdit,
  checkEditPeriodRulesForWarnings
} from 'redux/admin/Actions'

import {
  snackMessageError
} from 'redux/RootActions'

import DialogTitle from 'common/components/dialog/DialogTitle'
import DialogContent from 'common/components/dialog/DialogContent'
import DialogActions from 'common/components/dialog/DialogActions'
import FancySelect from 'common/components/FancySelect'
import BellRuleSVGHorizontal from "common/components/BellRuleSVGHorizontal"
import PillToggle from "common/components/PillToggle"
import BellRuleWarnings from './Warnings'

import styles from './style'
import {BELL_RULE_TOOLTIPS, BELL_RULE_LABELS} from './texts'
import {Divider} from "@material-ui/core";

import {minuteList, presentMinuteList} from './objects'
import {paModeList, AT_TYPE_ID_NOT_SET, AT_TYPE_ID_PRESENT, IS_TEACHER_REVIEW_ENABLED, PERIOD_RULE_AT_TYPE_TITLE_MAP} from "redux/constants";
import Typography from "@material-ui/core/Typography";
import ToggleIconButton from "common/components/ToggleIconButton";

const IS_OUT_OF_BUILDING_PROPAGATION_ENABLED = 'isOutOfBuildingPropagationEnabled';

class BellRulesDialog extends React.Component {

  guessTypes = () => {
    this.props.atTypeChoicesForSubPeriods.general.forEach(item => {
      switch(item.name) {
        case 'AE' :
          this.props.bellRulesEditUpdateProperty({
            propertyName:'atTypeAbsentExcusedId',
            val:item.id
          })
          break
        case 'AU' :
          this.props.bellRulesEditUpdateProperty({
            propertyName:'atTypeAbsentId',
            val:item.id
          })
          break
        case 'OOB' :
          this.props.bellRulesEditUpdateProperty({
            propertyName:'atTypeOutOfBuildingId',
            val:item.id
          })
          break
        /*case 'OOL' :
          this.props.bellRulesEditUpdateProperty({
            propertyName:'atTypeOutId',
            val:item.id
          })
          break */
        case 'TE' :
          this.props.bellRulesEditUpdateProperty({
            propertyName:'atTypeTardyExcusedId',
            val:item.id
          })
          break
        case 'TU' :
          this.props.bellRulesEditUpdateProperty({
            propertyName:'atTypeTardyId',
            val:item.id
          })
          break
      }
    })
  }

  handleOutOfBuildingPropagationUpdateProperty = ({ propertyName, val }) => {
    if (propertyName === IS_OUT_OF_BUILDING_PROPAGATION_ENABLED && val === true) {
      if (!this.props.bellSchedule.atTypeOutOfBuildingId) {
        alert('Please select "Out of Building" type before setting this option to "Yes"');
        return; 
      }
    }

    this.props.bellRulesEditUpdateProperty({ propertyName, val });
  };

  timingUpdate = ({propertyName, val}) => {
    if (propertyName !== 'bellPeriodPostStartAbsentSeconds' && propertyName !== 'bellPeriodPostStartTardySeconds') {
      this.props.bellRulesEditUpdateProperty({ propertyName, val })
      return
    }

    let tardyTime = this.props.bellSchedule.bellPeriodPostStartTardySeconds
    let absentTime = this.props.bellSchedule.bellPeriodPostStartAbsentSeconds
    if (propertyName === 'bellPeriodPostStartAbsentSeconds') {
      absentTime = val
    }
    if (propertyName === 'bellPeriodPostStartTardySeconds') {
      tardyTime = val
    }

    if (tardyTime !== -1 && absentTime !== -1 && tardyTime >= absentTime) {
      this.props.snackMessageError(`'${BELL_RULE_LABELS.bellPeriodPostStartTardySeconds}' should be less than '${BELL_RULE_LABELS.bellPeriodPostStartAbsentSeconds}'.`)
      return
    }
  
    this.props.bellRulesEditUpdateProperty({ propertyName, val })
  }

  render() {
    if(!this.props.bellSchedule) return null

    const {
      classes,
      bellRulesEditDone,
      bellRulesEditUpdateProperty,
      bellRulesEditSave,
      bellSchedule,
      atReasonChoicesForSubPeriods,
      atTypeChoicesForSubPeriods,
      positiveAttendanceIsEnabled,
      overridableAtTypesEdit,
      atTypes,
      currentFacilityId
       } = this.props

    const facilityOverridableAtTypes = atTypes.filter(atType => atType.facilityId === currentFacilityId && atType.kioskCanOverride);
    const bellScheduleAtTypeId = bellSchedule.atTypePresentId === AT_TYPE_ID_NOT_SET ? AT_TYPE_ID_PRESENT : bellSchedule.atTypePresentId;
    
    return (
      <Dialog
        onClose={bellRulesEditDone}
        aria-labelledby="customized-dialog-title"
        open={true}
        PaperProps={{
          style: { minWidth: '700px' }
        }}
      >
        <DialogTitle id="customized-dialog-title" onClose={bellRulesEditDone}>
          {BELL_RULE_LABELS.dialogTitle}
        </DialogTitle>
        <DialogContent className={classes.dialogContentRoot}>
          <BellRuleWarnings bellScheduleWarnings={this.props.editBellScheduleWarnings}/>

          {positiveAttendanceIsEnabled &&
            <Grid item xs={12} className={classes.paGridItem} style={{marginTop: 20, marginBottom: 4}}>
              <Tooltip title={BELL_RULE_TOOLTIPS.isPaEnabled}>
                <PillToggle
                  isOn={bellSchedule.isPaEnabled}
                  label={BELL_RULE_LABELS.positiveAttendance}
                  onClick={() => bellRulesEditUpdateProperty({ propertyName: 'isPaEnabled', val: !bellSchedule.isPaEnabled })}
                />
              </Tooltip>
            </Grid>
          }

          {/* === Attendance Codes === */}
          <Grid item xs={12} className={classes.gridItem}>
            <Typography className={classes.sectionLabel}>
              {BELL_RULE_LABELS.sectionAttendanceCodes}
            </Typography>
            <Divider className={classes.sectionDivider} />
          </Grid>
          <Grid container>
            <Grid item xs={6} className={classes.gridItem}>
              <FancySelect
                dispatchUpdate={bellRulesEditUpdateProperty}
                label={PERIOD_RULE_AT_TYPE_TITLE_MAP['atTypeTardyId']}
                propertyName='atTypeTardyId'
                currentItem={findOneBy(atTypeChoicesForSubPeriods.tardy, 'id', bellSchedule.atTypeTardyId)}
                items={atTypeChoicesForSubPeriods.tardy}
                nameAtr='displayName'
              />
            </Grid>
            <Grid item xs={6} className={classes.gridItem}>
              <FancySelect
                dispatchUpdate={bellRulesEditUpdateProperty}
                label={PERIOD_RULE_AT_TYPE_TITLE_MAP['atTypeTardyExcusedId']}
                propertyName='atTypeTardyExcusedId'
                currentItem={findOneBy(atTypeChoicesForSubPeriods.tardyExcused, 'id', bellSchedule.atTypeTardyExcusedId)}
                items={atTypeChoicesForSubPeriods.tardyExcused}
                nameAtr='displayName'
              />
            </Grid>
            <Grid item xs={6} className={classes.gridItem}>
              <FancySelect
                dispatchUpdate={bellRulesEditUpdateProperty}
                label={PERIOD_RULE_AT_TYPE_TITLE_MAP['atTypeAbsentId']}
                propertyName='atTypeAbsentId'
                currentItem={findOneBy(atTypeChoicesForSubPeriods.absent, 'id', bellSchedule.atTypeAbsentId)}
                items={atTypeChoicesForSubPeriods.absent}
                nameAtr='displayName'
              />
            </Grid>
            <Grid item xs={6} className={classes.gridItem}>
              <FancySelect
                dispatchUpdate={bellRulesEditUpdateProperty}
                label={PERIOD_RULE_AT_TYPE_TITLE_MAP['atTypeAbsentExcusedId']}
                propertyName='atTypeAbsentExcusedId'
                currentItem={findOneBy(atTypeChoicesForSubPeriods.absentExcused, 'id', bellSchedule.atTypeAbsentExcusedId)}
                items={atTypeChoicesForSubPeriods.absentExcused}
                nameAtr='displayName'
              />
            </Grid>
            <Grid item xs={6} className={classes.gridItem}>
              <FancySelect
                dispatchUpdate={bellRulesEditUpdateProperty}
                label={BELL_RULE_LABELS.atReasonDefaultId}
                propertyName='atReasonDefaultId'
                currentItem={findOneBy(atReasonChoicesForSubPeriods, 'id', bellSchedule.atReasonDefaultId)}
                items={atReasonChoicesForSubPeriods}
                nameAtr='displayName'
              />
            </Grid>
            <Grid item xs={6} className={classes.gridItem}>
              <FancySelect
                dispatchUpdate={bellRulesEditUpdateProperty}
                label={PERIOD_RULE_AT_TYPE_TITLE_MAP['atTypeOutOfBuildingId']}
                propertyName='atTypeOutOfBuildingId'
                currentItem={findOneBy(atTypeChoicesForSubPeriods.outOfBuilding, 'id', bellSchedule.atTypeOutOfBuildingId)}
                items={atTypeChoicesForSubPeriods.outOfBuilding}
                nameAtr='displayName'
              />
            </Grid>
            {positiveAttendanceIsEnabled && bellSchedule.isPaEnabled &&
              <Grid item xs={6} className={classes.gridItem}>
                <FancySelect
                  dispatchUpdate={bellRulesEditUpdateProperty}
                  label={BELL_RULE_LABELS.atTypePresentId}
                  propertyName='atTypePresentId'
                  currentItem={findOneBy(atTypeChoicesForSubPeriods.present, 'id', bellScheduleAtTypeId)}
                  items={atTypeChoicesForSubPeriods.present}
                  nameAtr='displayName'
                />
              </Grid>
            }
          </Grid>

          {/* === Attendance Timing Thresholds === */}
          <Grid item xs={12} className={`${classes.gridItem} ${classes.sectionHeader}`}>
            <Typography className={classes.sectionLabel}>
              {BELL_RULE_LABELS.sectionTimingThresholds}
            </Typography>
            <Divider className={classes.sectionDivider} />
          </Grid>
          <Grid container>
            {positiveAttendanceIsEnabled && bellSchedule.isPaEnabled &&
              <Grid item xs={4} className={classes.gridItem}>
                <Tooltip title={BELL_RULE_TOOLTIPS.bellPeriodPreStartPresentSeconds}>
                  <div className={classes.fieldWithIndicator}>
                    <FancySelect
                      dispatchUpdate={bellRulesEditUpdateProperty}
                      label={BELL_RULE_LABELS.bellPeriodPreStartPresentSeconds}
                      propertyName='bellPeriodPreStartPresentSeconds'
                      currentItem={findOneBy(presentMinuteList, 'seconds', bellSchedule.bellPeriodPreStartPresentSeconds)}
                      items={presentMinuteList}
                      valAtr='seconds'
                      nameAtr='displayName'
                    />
                    <div className={classes.presentIndicator} />
                  </div>
                </Tooltip>
              </Grid>
            }
            <Grid item xs={4} className={classes.gridItem}>
              <Tooltip title={BELL_RULE_TOOLTIPS.bellPeriodPostStartTardySeconds}>
                <div className={classes.fieldWithIndicator}>
                  <FancySelect
                    dispatchUpdate={this.timingUpdate}
                    label={BELL_RULE_LABELS.bellPeriodPostStartTardySeconds}
                    propertyName='bellPeriodPostStartTardySeconds'
                    currentItem={findOneBy(minuteList, 'seconds', bellSchedule.bellPeriodPostStartTardySeconds)}
                    items={minuteList}
                    valAtr='seconds'
                    nameAtr='displayName'
                  />   
                  <div className={classes.tardyIndicator} />
                </div>
              </Tooltip>
            </Grid>
            <Grid item xs={4} className={classes.gridItem}>
              <Tooltip title={BELL_RULE_TOOLTIPS.bellPeriodPostStartAbsentSeconds}>
                <div className={classes.fieldWithIndicator}>
                  <FancySelect
                    dispatchUpdate={this.timingUpdate}
                    label={BELL_RULE_LABELS.bellPeriodPostStartAbsentSeconds}
                    propertyName='bellPeriodPostStartAbsentSeconds'
                    currentItem={findOneBy(minuteList, 'seconds', bellSchedule.bellPeriodPostStartAbsentSeconds)}
                    items={minuteList}
                    valAtr='seconds'
                    nameAtr='displayName'
                  />
                  <div className={classes.absentIndicator} />
                </div>
              </Tooltip>
            </Grid>
            <Grid item xs={12} className={`${classes.gridItem} ${classes.svgContainer}`}>
              <BellRuleSVGHorizontal style={{maxWidth:'100%', flex: 1}} {...bellSchedule} positiveAttendanceIsEnabled={positiveAttendanceIsEnabled && bellSchedule.isPaEnabled} writeLog={true} />
            </Grid>
          </Grid>

          {/* === Attendance Logic === */}
          <Grid item xs={12} className={`${classes.gridItem} ${classes.sectionHeader}`} style={{marginTop: 5}}>
            <Typography className={classes.sectionLabel}>
              {BELL_RULE_LABELS.sectionAttendanceLogic}
            </Typography>
            <Divider className={classes.sectionDivider} />
          </Grid>

          <Grid>
            <Grid container style={{ alignItems: 'center'}}>
              <Tooltip title={BELL_RULE_TOOLTIPS.overridableAtTypes}>
              <Button onClick={() => overridableAtTypesEdit()} color="primary">{BELL_RULE_LABELS.overridableAtTypesButton}</Button>
              </Tooltip>
              <Typography style={{ marginLeft: '10px' }}>{`${facilityOverridableAtTypes.length} attendance types selected`}</Typography>
              <OverridableAttendanceTypesDialog/>
            </Grid>
          </Grid>

          <Grid container>
            <Grid item xs={12} className={classes.gridItem}>
              <Tooltip title={BELL_RULE_TOOLTIPS.isOutOfBuildingPropagationEnabled}>
              <Typography className={classes.logicToggleText}>
                <ToggleIconButton
                  onTitle='Enabled'
                  offTitle='Disabled'
                  isOn={!!bellSchedule[IS_OUT_OF_BUILDING_PROPAGATION_ENABLED]}
                  onClick={() => {
                    this.handleOutOfBuildingPropagationUpdateProperty({
                      propertyName: IS_OUT_OF_BUILDING_PROPAGATION_ENABLED,
                      val: !bellSchedule[IS_OUT_OF_BUILDING_PROPAGATION_ENABLED]
                    })
                  }}/>
                {BELL_RULE_LABELS.isOutOfBuildingPropagationEnabled}
              </Typography>
              </Tooltip>
            </Grid>

            <Grid item xs={12} className={classes.gridItem}>
              <Tooltip title={BELL_RULE_TOOLTIPS.isNonAttendancePeriodsEnabled}>
              <Typography className={classes.logicToggleText}>
                <ToggleIconButton
                  onTitle='Enabled'
                  offTitle='Disabled'
                  isOn={!!bellSchedule.isNonAttendancePeriodsEnabled}
                  onClick={()=>{
                    bellRulesEditUpdateProperty({
                      propertyName:'isNonAttendancePeriodsEnabled',
                      val:!bellSchedule.isNonAttendancePeriodsEnabled
                    })
                  }}/>
                {BELL_RULE_LABELS.isNonAttendancePeriodsEnabled}
              </Typography>
              </Tooltip>
            </Grid>
            
            <Grid item xs={12} className={classes.gridItem}>
              <Tooltip title={BELL_RULE_TOOLTIPS.isCreateInOutsEnabled}>
                <Typography className={classes.logicToggleTextFlex}>
                  <ToggleIconButton
                    onTitle='Enabled'
                    offTitle='Disabled'
                    isOn={!!bellSchedule.isCreateInOutsEnabled}
                    disabled={!bellSchedule.isCreateInOutsEnabled && bellSchedule.atTypeOutOfBuildingId === 0}
                    onClick={()=>{
                      bellRulesEditUpdateProperty({
                        propertyName:'isCreateInOutsEnabled',
                        val:!bellSchedule.isCreateInOutsEnabled
                      })
                    }}/>
                  {BELL_RULE_LABELS.isCreateInOutsEnabled}
                  <InfoIcon className={classes.infoIcon} />
                </Typography>
              </Tooltip>
            </Grid>
            {IS_TEACHER_REVIEW_ENABLED &&
              <Grid item xs={12} className={classes.gridItem}>
                <Tooltip title={BELL_RULE_TOOLTIPS.isAttendanceApproveRequired}>
                <Typography className={classes.logicToggleTextFlex}>
                  <ToggleIconButton
                    onTitle='Enabled'
                    offTitle='Disabled'
                    isOn={!!bellSchedule.isAttendanceApproveRequired}
                    onClick={()=>{
                      bellRulesEditUpdateProperty({
                        propertyName:'isAttendanceApproveRequired',
                        val:!bellSchedule.isAttendanceApproveRequired
                      })
                    }}/>
                  {BELL_RULE_LABELS.isAttendanceApproveRequired}
                </Typography>
                </Tooltip>
              </Grid>
            }
          </Grid>
        </DialogContent>
        <DialogActions style={{marginTop:10}}>
          <Button onClick={this.guessTypes} color="secondary">
            Guess Types
          </Button>
          <div style={{flexGrow:8}}/>
          <Button onClick={bellRulesEditDone} color="secondary">
            Cancel
          </Button>
          <Button onClick={bellRulesEditSave} color="primary">
            Save changes
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

const mapStateToProps = state => {
  const dialogState = state.admin.dialogs.bellRulesEditor ? state.admin.dialogs.bellRulesEditor : {};
  const atTypes = state.admin.atTypes ? state.admin.atTypes : [];
  const currentFacilityId =  state.admin.currentFacilityId;
  return { ...dialogState, atTypes, currentFacilityId, editBellScheduleWarnings: state.admin.editBellScheduleWarnings };
}

const mapDispatchToProps = {
  bellRulesEditDone,
  bellRulesEditUpdateProperty,
  bellRulesEditSave,
  overridableAtTypesEdit,
  checkEditPeriodRulesForWarnings,
  snackMessageError
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(BellRulesDialog))